import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { FormControlLabel, Switch } from "@mui/material";

import * as api from "../../../shared/lib/api";
import { activeLabel } from "../../../features/product/types/response-classification";

type ToggleRuleProps = {
	rule: {
		id: string;
		is_active: boolean;
	};
	onToggled?: (isActive: boolean) => void;
};

export function ToggleRule({ rule, onToggled }: ToggleRuleProps): JSX.Element {
	const [toggling, setToggling] = useState<boolean>(false);
	const [isActive, setIsActive] = useState<boolean>(rule.is_active);

	useEffect(() => {
		setIsActive(rule.is_active);
	}, [rule.is_active]);

	const handleToggleActive = async (active: boolean, ruleId: string) => {
		setToggling(true);
		setIsActive(active);

		try {
			if (active) {
				const res = (await api.put(
					`report/response-classification/reactivate/${ruleId}/`,
					{ is_active: active },
				)) as { [k: string]: any };

				if (res?.status === 200) {
					toast.success("Regra desbloqueada", {
						position: toast.POSITION.TOP_RIGHT,
					});
					onToggled?.(active);
				} else {
					throw new Error("bad status");
				}
			} else {
				const res = await api.destroy(
					`report/response-classification/destroy/${ruleId}/`,
				);
				if (res?.status === 204) {
					toast.success("Regra bloqueada", {
						position: toast.POSITION.TOP_RIGHT,
					});
					onToggled?.(active);
				} else {
					throw new Error("bad status");
				}
			}
		} catch (error) {
			setIsActive(rule.is_active);
			toast.error("Falha ao alterar regra.", {
				position: toast.POSITION.TOP_RIGHT,
			});
		} finally {
			setToggling(false);
		}
	};

	if (toggling) {
		return (
			<FormControlLabel
				control={<Switch checked={isActive} disabled />}
				label={activeLabel(isActive)}
			/>
		);
	}

	return (
		<FormControlLabel
			control={
				<Switch
					checked={isActive}
					onChange={(e) => handleToggleActive(e.target.checked, rule.id)}
				/>
			}
			label={activeLabel(isActive)}
		/>
	);
}
